import React, { useEffect, useState } from 'react'
import moment from 'moment'

// components
import {
  CCol,
  CFormLabel,
  CFormText,
  CRow
} from '@coreui/react-pro'
import AppTextColumnDetails from '../general-details/AppTextColumnDetails'
import { getFullName } from 'src/helpers/text-format'
import { getFullPhoneNumber } from 'src/helpers/text-format'

// helpers
import Axios from 'src/helpers/axios'

const AppFirstDetails = ({
  customerDetails,
  shippingAddressDetails
}) => {
  const [subDistrictDetails, setSubDistrictDetails] = useState(null)
  const [districtDetails, setDistrictDetails] = useState(null)
  const [cityDetails, setCityDetails] = useState(null)
  const [provinceDetails, setProvinceDetails] = useState(null)

  useEffect(() => {
    if (shippingAddressDetails && shippingAddressDetails?.district_id && shippingAddressDetails?.subdistrict_id) {
      fetchSubDistrictDetails(shippingAddressDetails?.district_id, shippingAddressDetails.subdistrict_id)
    }
    if (shippingAddressDetails && shippingAddressDetails?.city_id && shippingAddressDetails?.district_id) {
      fetchDistrictDetails(shippingAddressDetails?.city_id, shippingAddressDetails?.district_id)
    }
    if (shippingAddressDetails && shippingAddressDetails?.province_id && shippingAddressDetails?.city_id) {
      fetchCityDetails(shippingAddressDetails?.province_id, shippingAddressDetails?.city_id)
    }
    if (shippingAddressDetails && shippingAddressDetails.province_id) {
      fetchProvinceDetails(shippingAddressDetails.province_id)
    }
  }, [shippingAddressDetails]);

  const fetchSubDistrictDetails = (districtId, subdistrictId) => {
    Axios({
      method: "get",
      url: `/api/ecommerce/v1/countries/subdistricts/details/${subdistrictId}/district/${districtId}`,
    })
      .then(({ data }) => {
        setSubDistrictDetails(data)
      })
      .catch((err) => {
        console.error(err);
      });
  }

  const fetchDistrictDetails = (cityId, districtId) => {
    Axios({
      method: "get",
      url: `/api/ecommerce/v1/countries/districts/details/${districtId}/city/${cityId}`,
    })
      .then(({ data }) => {
        setDistrictDetails(data)
      })
      .catch((err) => {
        console.error(err);
      });
  }

  const fetchCityDetails = (provinceId, cityId) => {
    Axios({
      method: "get",
      url: `/api/ecommerce/v1/countries/cities/details/${cityId}/province/${provinceId}`,
    })
      .then(({ data }) => {
        setCityDetails(data)
      })
      .catch((err) => {
        console.error(err);
      });
  }

  const fetchProvinceDetails = (provinceId) => {
    Axios({
      method: "get",
      url: `/api/ecommerce/v1/countries/provinces/details/${provinceId}`,
    })
      .then(({ data }) => {
        setProvinceDetails(data)
      })
      .catch((err) => {
        console.error(err);
      });
  }

  const isAddressHasValue = shippingAddressDetails?.street_address || shippingAddressDetails?.address_details || subDistrictDetails?.label || districtDetails?.label || cityDetails?.label || provinceDetails?.label || shippingAddressDetails?.country?.name && shippingAddressDetails?.postal_code
  
  return (
    <CRow>
      <CCol lg='3'>
        <CRow>
          <AppTextColumnDetails
            colSize="12"
            className="mb-3"
            title="Customer ID"
            subtitle={customerDetails?.user_uuid ? customerDetails?.user_uuid : '-'}
          />
        </CRow>
        <CRow>
          <AppTextColumnDetails
            colSize="12"
            className="mb-3"
            title="Username"
            subtitle={customerDetails?.username ? customerDetails?.username : '-'}
          />
        </CRow>
        <CRow>
          <AppTextColumnDetails
            colSize="12"
            className="mb-3"
            title="First Name"
            subtitle={customerDetails?.profile?.first_name || shippingAddressDetails?.first_name || shippingAddressDetails?.contact_information_first_name || '-'}
          />
        </CRow>
        <CRow>
          <AppTextColumnDetails
            colSize="12"
            className="mb-3"
            title="Last Name"
            subtitle={customerDetails?.profile?.last_name || shippingAddressDetails?.last_name || shippingAddressDetails?.contact_information_last_name || '-'}
          />
        </CRow>
      </CCol>
      <CCol lg='3'>
        <CRow>
          <AppTextColumnDetails
            colSize="12"
            className="mb-3"
            title="Registered On"
            subtitle={moment(customerDetails?.createdAt).format('DD/MM/YYYY HH:mm')}
          />
        </CRow>
        <CRow>
          <AppTextColumnDetails
            colSize="12"
            className="mb-3"
            title="Gender"
            subtitle={customerDetails?.profile?.gender || '-'}
          />
        </CRow>
        <CRow>
          <AppTextColumnDetails
            colSize="12"
            className="mb-3"
            title="Email Address"
            subtitle={customerDetails?.email}
          />
        </CRow>
        <CRow>
          <AppTextColumnDetails
            colSize="12"
            className="mb-3"
            title="Phone Number"
            subtitle={getFullPhoneNumber(customerDetails?.profile)}
          />
        </CRow>
      </CCol>
      <CCol lg='3'>
        <CFormLabel>
          Address
        </CFormLabel>
        <CRow>
          <CCol lg='12' className='mb-3'>
            <CFormText className='customer-details-address-list'>
              {isAddressHasValue ? `${shippingAddressDetails?.street_address || ""} ${shippingAddressDetails?.address_details || ""} ${subDistrictDetails?.label ? subDistrictDetails?.label + ", " : ""}${districtDetails?.label ? districtDetails?.label + ", " : ""}${cityDetails?.label ? cityDetails?.label + ", " : ""}${provinceDetails?.label ? provinceDetails?.label + ", " : ""} ${shippingAddressDetails?.country?.name ? shippingAddressDetails?.country?.name + ", " : ""} ${shippingAddressDetails?.postal_code || ""}` : "-"}
              {isAddressHasValue && (
                <p className='customer-details-main-shipping-address'>{shippingAddressDetails?.address_name}</p>
              )}
            </CFormText>
            {/* <CFormText className='customer-details-address-list'>
              Paterson Road 2810 block 21 Sydney, NSW 2000 Australia
            </CFormText>
            <CFormText className='customer-details-address-list'>
              Paterson Road 2810 block 21 Sydney, NSW 2000 Australia
            </CFormText>
            <CFormText className="d-flex justify-content-between align-items-center">
              <p>+3 more address</p>
              <p>VIEW ALL</p>
            </CFormText> */}
          </CCol>
        </CRow>
      </CCol>
    </CRow>
  )
}

export default AppFirstDetails
